module.exports = __webpack_public_path__ + "static/media/cometa.29afce85.png";